module.exports = __webpack_public_path__ + "img/teaching_7.630e00de.png";